import React from "react";
import Tr from "../../Utils/Translations/Translations";
import Generic from "../../Utils/Generic";
import { Icon } from "@fluentui/react";
import "./MissionPage.scss";

const MissionPage = () => {
  return (
    <div
      className="mission-page-wrap"
      style={Generic.GetRandomBackgroundUrlCss()}
    >
      <div className="mission-overlay">
        <div className="mission-content-container">
          {/* Hero Section */}
          <section className="mission-hero">
            <h1 className="main-title">
              {Tr.Translate("presentation", "mission_title")}
            </h1>
            <h2 className="sub-title">
              {Tr.Translate("presentation", "mission_subtitle")}
            </h2>
          </section>

          {/* Cards Section */}
          <section className="mission-cards-grid">
            {/* Card 1: Consistency & AI */}
            <div className="mission-card">
              <div className="card-icon">
                <Icon iconName="AutoEnhanceOn" /> {/* Icona "Magic/AI" */}
              </div>
              <h3>{Tr.Translate("presentation", "mission_p1_title")}</h3>
              <p>{Tr.Translate("presentation", "mission_p1_desc")}</p>
            </div>

            {/* Card 2: Structure & Complexity */}
            <div className="mission-card">
              <div className="card-icon">
                <Icon iconName="CityNext" /> {/* Icona "Structure/Building" */}
              </div>
              <h3>{Tr.Translate("presentation", "mission_p2_title")}</h3>
              <p>{Tr.Translate("presentation", "mission_p2_desc")}</p>
            </div>
          </section>

          {/* Founder Section */}
          <section className="mission-founder-note">
            <div className="founder-icon">
              <Icon iconName="Story" /> {/* Icona "Book/Story" */}
            </div>
            <div className="founder-text">
              <h3>{Tr.Translate("presentation", "mission_founder_title")}</h3>
              <blockquote>
                "{Tr.Translate("presentation", "mission_founder_desc")}"
              </blockquote>
              <div className="founder-signature">— PlotterStudio Founder</div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MissionPage;
